import { Component, inject } from '@angular/core';
import { InfoComponent } from '../info/info.component';
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { NgClass, NgTemplateOutlet } from "@angular/common";
import { TriggersList } from '../../variables';

@Component({
    selector: 'app-advanced-aml-protection-triggers-table',
    imports: [TranslateModule, NgTemplateOutlet, NgClass],
    templateUrl: './advanced-aml-protection-triggers-table.component.html',
    styleUrl: './advanced-aml-protection-triggers-table.component.scss'
})
export class AdvancedAmlProtectionTriggersTableComponent {
  private readonly _translateService: TranslateService = inject(TranslateService);
  triggerList = TriggersList;
  currentLang = this._translateService.currentLang;
}
